import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-162ee7a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Choose a tree to share: ", -1))
const _hoisted_2 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_3 = { class: "list-unstyled" }
const _hoisted_4 = {
  key: 1,
  class: "alert alert-warning alert-sm"
}

import { computed, ref } from "vue"
import { useDataGroupStore } from "@/gp/DataGroupStore"
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { LoadMode } from "@/util/AsyncData"
import { useTokenManager } from "@/auth/TokenManager"
import { useTelemetry } from "@/util/Telemetry"
import { useUserStore } from "@/gp/UserStore"
import { DataGroup, DataGroupMember, DataGroupType, PrincipalType } from "@/gp/GroupAdminModel"
import { hideModalAsync, LimitedStatus } from "@/util/AppUtil"
import Modal from '@/util/Modal.vue'
import ResearchGroupCard from '@/manage/researchgroups/ResearchGroupCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataGroupChooseShareModal',
  emits: [
  'requestShare'
],
  setup(__props, { expose: __expose, emit }) {



__expose({
  open
})

const familyGroupIdRef = ref<string>()
const excludeIdsRef = ref<string[]>([])
const selectedDataGroupIdRef = ref<string>()

const modalRef = ref<InstanceType<typeof Modal>>()

const dataGroupStore = useDataGroupStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const userStore = useUserStore()
const tokenManager = useTokenManager()
const { trackException } = useTelemetry()

const dataGroupsRef = computed(() => dataGroupStore.getVisibleGroups(LoadMode.EnsureLoaded)
  .filter(dg => dg.groupType == DataGroupType.Research && !excludeIdsRef.value.includes(dg.id!)))
const selectedDataGroupRef = computed(() => dataGroupsRef.value.find(dg => dg.id == selectedDataGroupIdRef.value))

const canShareRef = computed(() => !!selectedDataGroupRef.value && !selectedIsLimitedRef.value)
const isDataGroupOwnerRef = computed(() => selectedDataGroupRef.value?.ownerId == tokenManager.current.userId)
const useSharingRequestRef = computed(() => selectedDataGroupRef.value && !isDataGroupOwnerRef.value)
const shareTextRef = computed(() => useSharingRequestRef.value ? "Request share" : "Share")
const selectedIsLimitedRef = computed(() => {
  const owner = userStore.getAsyncUser(selectedDataGroupRef.value?.ownerId)?.data // loaded with DG
  return !isDataGroupOwnerRef.value && owner?.limits?.sharingLimit
})

function open(familyGroupId: string, excludeIds?: string[]) {
  familyGroupIdRef.value = familyGroupId
  excludeIdsRef.value = excludeIds ?? []
  selectedDataGroupIdRef.value = undefined
  modalRef.value?.open()
}

function getStatus(dataGroup: DataGroup) {
  if (dataGroup.ownerId == tokenManager.current.userId) {
    return undefined // show default status (in this case, "owner") for own trees
  }
  const owner = userStore.getAsyncUser(dataGroup.ownerId)?.data // loaded with DG
  return owner?.limits?.sharingLimit ? LimitedStatus : undefined
}

function onSelected(dataGroupId: string) {
  if (dataGroupId == selectedDataGroupIdRef.value) {
    selectedDataGroupIdRef.value = undefined // unselect
  } else {
    selectedDataGroupIdRef.value = dataGroupId
  }
}

async function onShare() {
  if (selectedDataGroupIdRef.value && selectedDataGroupRef.value?.ownerId == tokenManager.current.userId) {
    try {
      // share now
      const member = new DataGroupMember()
      member.dataGroupId = selectedDataGroupIdRef.value
      member.principalType = PrincipalType.FamilyGroup
      member.principalId = familyGroupIdRef.value!
      await dataGroupMemberStore.addAsync(selectedDataGroupIdRef.value, member)
      modalRef.value?.close()
    }
    catch (error) {
      trackException(error)
      modalRef.value?.reset()
    }
  }
  else {
    await hideModalAsync(modalRef.value!.$el)
    emit('requestShare', selectedDataGroupIdRef.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "choose-share-modal",
    "ok-disabled": !canShareRef.value,
    onOk: onShare
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Share a tree ")
    ]),
    okText: _withCtx(() => [
      _createTextVNode(_toDisplayString(shareTextRef.value), 1)
    ]),
    busyText: _withCtx(() => [
      _createTextVNode("Sharing...")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (!dataGroupsRef.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (excludeIdsRef.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" No other trees are available to share. ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" No trees are available to share. ")
                ], 64))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataGroupsRef.value, (dg) => {
          return (_openBlock(), _createElementBlock("li", {
            key: dg.id
          }, [
            _createVNode(ResearchGroupCard, {
              "data-group-id": dg.id!,
              small: "",
              "select-mode": "",
              "selected-id": selectedDataGroupIdRef.value,
              status: getStatus(dg),
              onSelected: ($event: any) => (onSelected(dg.id!))
            }, null, 8, ["data-group-id", "selected-id", "status", "onSelected"])
          ]))
        }), 128))
      ]),
      (selectedIsLimitedRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " The owner of the selected tree has a limited plan that does not allow sharing with groups managed by other users. "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["ok-disabled"]))
}
}

})